import storage from './storage';

export const setStatus = status => storage.setItem('userStatus', status);

export const getStatus = () => storage.getItem('userStatus');

export const removeStatus = () => storage.removeItem('userStatus');
